import React from "react";

const DigitalTimer = ({ seconds }) => {
  const value = seconds < 10 ? `0:${seconds}` : `0:${seconds}`;

  return (
    <span
      className="
        font-mono
        text-xl
        tracking-widest
        text-red-500
        drop-shadow-[0_0_6px_rgba(255,0,0,0.8)]
        drop-shadow-[0_0_12px_rgba(255,0,0,0.6)]
      "
    >
      {value}
    </span>
  );
};

export default DigitalTimer;
